"use strict";
/**
 * Created by Ning Jiang on 11/21/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformanceMarkName = void 0;
class PerformanceMarkName {
}
PerformanceMarkName.SPIN_START = "SPIN START";
PerformanceMarkName.SPIN_STOPPING = "SPIN STOPPING";
PerformanceMarkName.SPIN_ANIMATION_COMPLETED = "SPIN ANIMATION COMPLETED";
PerformanceMarkName.SPIN_STOP_PRESENTATION_COMPLETED = "SPIN STOP PRESENTATION COMPLETED";
PerformanceMarkName.SPIN_COMPLETED = "SPIN COMPLETED";
PerformanceMarkName.GAME_DATA_RECEIVED = "GAME DATA RECEIVED";
exports.PerformanceMarkName = PerformanceMarkName;
//# sourceMappingURL=PerformanceMarkName.js.map